module.exports = __webpack_public_path__ + "images/icons_v2/selling-sheets-566a2d54.svg";